import _taggedTemplateLiteralLoose from 'babel-runtime/helpers/taggedTemplateLiteralLoose';

var _templateObject = _taggedTemplateLiteralLoose(['\n  mutation sendAnalyticEvent($analyticEvent: AnalyticEvent!) {\n    sendAnalyticEvent(analyticEvent: $analyticEvent)\n  }\n'], ['\n  mutation sendAnalyticEvent($analyticEvent: AnalyticEvent!) {\n    sendAnalyticEvent(analyticEvent: $analyticEvent)\n  }\n']);

import gql from 'graphql-tag';

export var AnalyticEventMutation = gql(_templateObject);